const f = {
  color: {
    default: "#314351ff",
    dotBackground: {
      default: "#ffffffff",
      active: "#4176faff"
    },
    border: "#c8d3deff",
    dotBorder: {
      default: "#abb9c7ff",
      active: "#4176faff"
    }
  },
  item: {
    color: {
      text: "#314351ff",
      dot: {
        active: "#47c2ffff"
      }
    }
  }
};
export {
  f as timeline
};
